module.exports = __webpack_public_path__ + "img/freespin1_multiplier5.3f9f372e.png";